//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { InstagramAccountDraftsAction } from '@instagram-account/redux/drafts/instagramAccountDraftsActions';
import {
  IInstagramAccountDraftsState,
  INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS,
} from '@instagram-account/redux/drafts/instagramAccountDraftsModel';
import normalize from '@utils/normalize';

const initialState: IInstagramAccountDraftsState = {
  draftPosts: undefined,
  flags: {
    hasFetchedDrafts: false,
    isFetchingDrafts: false,
    isSavingDraft: false,
    isDeletingDraft: false,
    isSwappingDraftStatus: false,
  },
};

export function reducer(
  state: IInstagramAccountDraftsState = initialState,
  action: InstagramAccountDraftsAction,
): IInstagramAccountDraftsState {
  switch (action.type) {
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.REQUEST_DRAFTS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDrafts: true,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_DRAFTS_SUCCEEDED: {
      const draftPosts = normalize(action.draftPosts, (post) => post.id);
      return {
        ...state,
        draftPosts,
        flags: {
          ...state.flags,
          isFetchingDrafts: false,
          hasFetchedDrafts: true,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_DRAFTS_FAILED: {
      return {
        ...state,
        fetchDraftsError: action.message,
        flags: {
          ...state.flags,
          isFetchingDrafts: false,
          hasFetchedDrafts: true,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.REQUEST_SAVE_DRAFT: {
      return {
        ...state,
        saveDraftError: initialState.saveDraftError,
        flags: {
          ...state.flags,
          isSavingDraft: true,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_SAVE_DRAFT_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingDraft: false,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_SAVE_DRAFT_FAILED: {
      return {
        ...state,
        saveDraftError: action.message,
        flags: {
          ...state.flags,
          isSavingDraft: false,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.REQUEST_DELETE_DRAFT: {
      return {
        ...state,
        deleteDraftError: initialState.deleteDraftError,
        flags: {
          ...state.flags,
          isDeletingDraft: true,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_DELETE_DRAFT_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isDeletingDraft: false,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_DELETE_DRAFT_FAILED: {
      return {
        ...state,
        deleteDraftError: action.message,
        flags: {
          ...state.flags,
          isDeletingDraft: false,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.REQUEST_SWAP_DRAFT_STATUS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSwappingDraftStatus: true,
        },
        swapDraftStatusError: initialState.swapDraftStatusError,
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_SWAP_DRAFT_STATUS_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSwappingDraftStatus: false,
        },
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.RECEIVE_SWAP_DRAFT_STATUS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSwappingDraftStatus: false,
        },
        swapDraftStatusError: action.message,
      };
    }
    case INSTAGRAM_ACCOUNT_DRAFTS_ACTIONS.CLEAR_SWAP_STATUS_ERROR: {
      return {
        ...state,
        swapDraftStatusError: initialState.swapDraftStatusError,
      };
    }
    default:
      return state;
  }
}
